import { Component, Inject, Input } from 'ng-metadata/core';
import { NgrsService } from './ngrs.service';
import { JwtUtilService } from "../../../security/jwtUtil.service";
import { PhysicalBestOfferService } from './physicalBestOffer/physicalBestOffer.service';
import { BestOffer, OfferOutputResults, mmsIdOfferOutputMap } from "./BestOffer.interface";
import { SharedSessionStorage } from '../../../infra/sharedSessionStorage.service';
import { getResourceType } from '../../../infra/ngrsUtil';
import { PickupAnywhereService } from './pickup-anywhere-form/pickupAnywhereForm.service';
import {
    getCalcServicesThenNgrsEnabled,
    getRapidILLModeCustomerParameter,
    isShowPhysicalJournalOffer
} from '../../../appConfig/appConfigForward';
import {ConfigurationUtil} from "../../../nddUtils/configurationUtil.service";
import {FullViewService} from "../fullView.service";

const get = require('lodash/get');
const injector = angular.injector(['ng']);
const $q: ng.IQService = injector.get('$q');
const PICKUP_AT_LIBRARY = 'pickupAtLibrary';
const HOME_DELIVERY = 'homeDelivery';
const OFFICE_DELIVERY = 'officeDelivery';
const RAPIDO_DIGITAL_TILE = 'RapidoDigitalTile';
const RAPIDO_PHYSICAL_TILE = 'RapidoPhysicalTile';
const RAPIDO_JOURNAL_TILE = 'RapidoJournalTile';
const RAPIDO_EBOOK_TILE = 'RapidoEbookTile';
const PICKUP_OPTIONS = {'homeDelivery':'nui.ngrs.request.home_delivery','officeDelivery':'nui.ngrs.request.office_delivery'};


@Component({
    "selector": "prm-service-ngrs",
    templateUrl: 'components/search/fullView/ngrs/ngrs.html'
})

export class PrmServiceNgrs {

    @Input() item: Object;
    private _digitalOfferFound: Boolean = false;
    private _physicalOfferFound: Boolean = false;
    private _hasBothOffers: Boolean = false;
    private _display: Object;
    private _openDigitalForm: Object;
    private _openPhysicalForm: Object;
    private _openBlankForm: Object;
    private _isSubmitDigital: Object;
    private _digitalSupplyTime: Object;
    private _bestOffer: BestOffer;
    private _digitalBestOffer: BestOffer;
    private _offers: Object[];
    private _almaRSServiceAvailable: string = null;
    private _showMoreDeliveryOptions: Object;
    private _mmsId: string;
    private offerPromises = [];
    private _picLocs: Object;
    private _showMessageBar: {
        showMessageBar: boolean,
        borrowingRequestOK: boolean,
        message: string
    };

    private globalIndexArr: string;
    private pickUpAnywhereEnabled = false;
    private pickupInformationData: any;
    private _showPickupAnywhereForm = false;
    private _pickupInformationPlaceholder: string;
    private _pickupInformationSelected: boolean = false;
    private _cannotCalculateOffer: boolean = false;
    private _pickupInformation: {
        institutionCode: string,
        institutionName: string,
        libraryId: string,
        libraryName: string,
        pickupInformationUpdated: boolean,
        isSelected: boolean,
        chosenPlaceRadio: string;
    }

    private _formsCustomization: any;
    private rapidoServices: Array<any> = [];
    private physicalTileVisible: boolean = false;
    private _noOfferFoundPhysicalTile: boolean;
    private digitalTileVisible: boolean = false;
    private _noOfferFoundDigitalTile: boolean;
    private _digitalTilePlaceholderActive: boolean;
    private _physicalTilePlaceholderActive: boolean;
    private resultObject: mmsIdOfferOutputMap[] = [];
    private physicalOfferCalculated: boolean;
    private digitalOfferCalculated: boolean;
    private podPriorityList: any = {};


    constructor(private physicalBestOfferService: PhysicalBestOfferService, private ngrsService: NgrsService,
                private jwtUtilService: JwtUtilService,
                private sharedSessionStorage: SharedSessionStorage,
                private pickupAnywhereService: PickupAnywhereService,
                private configurationUtil: ConfigurationUtil,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('$scope') private $scope: ng.IScope,
                private fullViewService: FullViewService) {

        this._almaRSServiceAvailable = null;
        this._pickupInformation = {
            institutionCode: undefined,
            institutionName: undefined,
            libraryId: undefined,
            libraryName: undefined,
            pickupInformationUpdated: false,
            isSelected: false,
            chosenPlaceRadio: undefined
        };

        this.pickUpAnywhereEnabled = window.appConfig['system-configuration'].ngrs_pickup_anywhere;
    }


    ngOnInit() {
        this._display = { display: 'display:none' };
        this._almaRSServiceAvailable = null;
        this._openDigitalForm = { openDigitalForm: false };
        this._openPhysicalForm = { openPhysicalForm: false };
        this._openBlankForm= {openBlankForm:false};
        this._isSubmitDigital = { isSubmitDigital: false };
        this._showMessageBar={showMessageBar:false,
            borrowingRequestOK: false,
            message:""};
        this._showPickupAnywhereForm = false;

        this._hasBothOffers = false;
        this._picLocs = { picLocs: [] };
        this._showMoreDeliveryOptions = { showMoreDeliveryOptions: false };
        this._bestOffer = <BestOffer>{};
        this._digitalBestOffer = <BestOffer>{};

        let result = this.ngrsService.getTitleRecordIdFromItem(this.item);
        let mmsIdArr = result[0];
        let globalIndexArr = result[1];
        if(!mmsIdArr){
            this._display={display:'display:block'};
            this._almaRSServiceAvailable = 'false';
        }else{
            this._mmsId = mmsIdArr[0];
            this.checkForRapidoOffer(globalIndexArr);
            this.getPodPriorityList();
        }
    }

    private checkForRapidoOffer(globalIndexArr) {
        this.digitalOfferCalculated = false;
        this.physicalOfferCalculated = false;
        let hideTilesDlr = window.appConfig['system-configuration'].hide_rapido_offers_tiles;
        let ngrsCheckFinishedPromiseResolve;
        let ngrsCheckFinishedPromise = new Promise((res) => {  ngrsCheckFinishedPromiseResolve = res;});
        if(hideTilesDlr && !this.isSignedIn()){
            this._almaRSServiceAvailable = "false";
        }else if(this.pickUpAnywhereEnabled){
            this.checkAlmaRSservice(this.item, this.isJournal(), ngrsCheckFinishedPromiseResolve).then(()=>{
                if(this._almaRSServiceAvailable && this._almaRSServiceAvailable === 'true'){
                    this.ngrsService.getRapidoFormsCustomization().then(result=> {
                        if(result){
                            this._formsCustomization = result;
                        }
                    });
                }
            });
            this.handlePickupInformation().then(()=>{
                this.checkForOffer(globalIndexArr, ngrsCheckFinishedPromise);
            });
        } else {
            this.checkAlmaRSservice(this.item, this.isJournal(), ngrsCheckFinishedPromiseResolve).then(()=>{
                if(this._almaRSServiceAvailable && this._almaRSServiceAvailable === 'true'){
                    this.ngrsService.getRapidoFormsCustomization().then(result=> {
                        if(result){
                            this._formsCustomization = result;
                        }
                    });
                }
            });
            this.checkForOffer(globalIndexArr, ngrsCheckFinishedPromise);
        }
    }

    public handlePickupInformation(){
        var deferred = $q.defer();
        this.pickupAnywhereService.getPickupInformation().then(result=> {
            if(result){
                this.pickupInformationData = result;
                this.handlePickupPreferenceResult(result);
            }
            deferred.resolve();
        });

        return deferred.promise;
    }

    public handlePickupPreferenceResult(result){
        let userPreference = result.userPreference;
        if(userPreference){
            this._pickupInformation.institutionCode = userPreference.pickupInformation.institutionCode;
            this._pickupInformation.institutionName = userPreference.pickupInformation.institutionName;
            this._pickupInformation.libraryId = userPreference.pickupInformation.libraryId;
            this._pickupInformation.libraryName = userPreference.pickupInformation.libraryName;
            this._pickupInformation.chosenPlaceRadio = userPreference.chosenPlaceRadio;
            if(this._pickupInformation.institutionCode ||
                (userPreference.chosenPlaceRadio && (userPreference.chosenPlaceRadio === HOME_DELIVERY || userPreference.chosenPlaceRadio === OFFICE_DELIVERY))){
                this._pickupInformationSelected = true;
            }

            if(userPreference.chosenPlaceRadio && userPreference.chosenPlaceRadio !== PICKUP_AT_LIBRARY){
                this._pickupInformationPlaceholder = this.$translate.instant(PICKUP_OPTIONS[userPreference.chosenPlaceRadio]);
            } else if(userPreference.pickupInformation.institutionName && userPreference.pickupInformation.libraryName) {
                this._pickupInformationPlaceholder = userPreference.pickupInformation.institutionName + ' - ' + userPreference.pickupInformation.libraryName;
            } else {
                this._pickupInformationPlaceholder = userPreference.pickupInformation.institutionName ? userPreference.pickupInformation.institutionName : userPreference.pickupInformation.libraryName;
            }

            if((userPreference.pickupInformation.institutionCode && userPreference.pickupInformation.libraryId) ||
                (userPreference.chosenPlaceRadio && (userPreference.chosenPlaceRadio === HOME_DELIVERY || userPreference.chosenPlaceRadio === OFFICE_DELIVERY))){
                this.pickupAnywhereService.setSelectedPickupInformation(this._pickupInformation);
            }
        }
    }

    public get pickupInformationInstCode(){
        return this._pickupInformation.institutionCode;
    }

    public get pickupInformationLibraryId(){
        return this._pickupInformation.libraryId;
    }

    public get chosenPlaceRadio(){
        return this._pickupInformation.chosenPlaceRadio;
    }

    private checkForOffer(globalIndexArr, ngrsCheckFinishedPromise){
        this.globalIndexArr = globalIndexArr;
        let hash = this.jwtUtilService.getDecodedToken().userGroup + '_' + this._mmsId;
        this.resultObject[hash] = [];
        if(this.physicalBestOfferService.getResultsObject() && this.physicalBestOfferService.getResultsObject()[hash]) {
            if (getCalcServicesThenNgrsEnabled()) {
                ngrsCheckFinishedPromise.then(() => {
                    this.setbestOffer(this.physicalBestOfferService.getResultsObject(), hash);
                });
            } else {
                this.setbestOffer(this.physicalBestOfferService.getResultsObject(), hash);
            }
        } else {
            if (!getRapidILLModeCustomerParameter()){
                // calculate physical offer
                if (globalIndexArr && (globalIndexArr[0].indexOf('cdi_globaltitleindex_catalog_') === 0
                    || globalIndexArr[0].indexOf('globaltitleindex_catalog_') === 0)) {
                    this.physicalBestOfferService.getbestOfferByGlobalIndex(this._mmsId,this.item, this.pickupAnywhereService.getSelectedPickupInformation(), null, true)
                        .then(response => {
                            if (getCalcServicesThenNgrsEnabled()) {
                                ngrsCheckFinishedPromise.then(() => {
                                    this.setBestPhysicalOffer(response, hash);
                                });
                            } else {
                                this.setBestPhysicalOffer(response, hash);
                            }
                        });
                } else {
                    this.physicalBestOfferService.getbestOffer(this._mmsId,this.item, this.pickupAnywhereService.getSelectedPickupInformation(), null, true)
                        .then(response => {
                            if (getCalcServicesThenNgrsEnabled()) {
                                ngrsCheckFinishedPromise.then(() => {
                                    this.setBestPhysicalOffer(response, hash);
                                });
                            } else {
                                this.setBestPhysicalOffer(response, hash);
                            }
                        });
                }
            }
            // calculate digital offer
            if (!this.isJournal()){
                this.physicalBestOfferService.getDigitalBestOffer(this._mmsId,this.item).then(response => {
                    if (getCalcServicesThenNgrsEnabled()) {
                        ngrsCheckFinishedPromise.then(() => {
                            this.setBestDigitalOffer(response, hash);
                        });
                    } else {
                        this.setBestDigitalOffer(response, hash);
                    }
                });
            } else {
                if (getCalcServicesThenNgrsEnabled()) {
                    ngrsCheckFinishedPromise.then(() => {
                        this.setBestDigitalOffer(null, hash);
                    });
                } else {
                    this.setBestDigitalOffer(null, hash);
                }
            }
        }
    }

    private setBestPhysicalOffer(response: mmsIdOfferOutputMap[], hash:string) {
        this.physicalOfferCalculated = true;
        this.setPhysicalOffer(response, hash);
        this._physicalOfferFound = this.isPhysicalOfferFound(this._bestOffer);
        this.resultObject[hash].bestPhysicalPolicy = this._bestOffer;
        this.resultObject[hash].bestEbookPolicy = this.getEbookOffer(response, hash);
        this.resultObject[hash].cannotCalculateOffer = this._cannotCalculateOffer;
        this.physicalBestOfferService.setResultsObject(this.resultObject, hash);

        if (this.podListIncludeseBookOffer()) {
            this.handleEbookOffer(response, hash);
        }

        if (!this._bestOffer || !this._bestOffer.ebookOffer) {
            this.rapidoServices.forEach(service => {
                if(service.serviceType == RAPIDO_PHYSICAL_TILE) {
                    this._noOfferFoundPhysicalTile = !!((service.noKnownTerms == 'true' && !this._physicalOfferFound) || (service.noKnownTerms == 'false' && this._physicalOfferFound));
                }
            });
        }

        this._physicalTilePlaceholderActive = false;
    }

    private handleEbookOffer(response: mmsIdOfferOutputMap[], hash:string, calculatedEbookOffer?: BestOffer) {
        let eBookOffer = calculatedEbookOffer != null ? calculatedEbookOffer : this.getEbookOffer(response, hash);
        let eBookOfferEnabled = this.isEbookTileEnablled();
        let physicalOfferEnabled = this.isPhysicalTileEnablled();
        if (eBookOffer != null && this._physicalOfferFound && !this.getNoOfferFoundPhysicalTile() && eBookOfferEnabled) {
            let groupHash = this.jwtUtilService.getDecodedToken().userGroup;
            this.getPodPriorityList();
            for (let key of Object.keys(this.podPriorityList[groupHash])) {
                if(this._bestOffer && key == this._bestOffer.podId) {
                    break;
                }
                if(key == eBookOffer.podId) {
                    this._bestOffer = eBookOffer;
                    this._physicalOfferFound = true;
                    if (getCalcServicesThenNgrsEnabled()) {
                        this._almaRSServiceAvailable = !physicalOfferEnabled ? 'true' : this._almaRSServiceAvailable;
                        this.physicalTileVisible = true;
                        this._hasBothOffers = this.physicalTileVisible && this.digitalTileVisible;
                    }
                    break;
                }
            }
        } else if ((eBookOffer != null && !this._physicalOfferFound && eBookOfferEnabled) ||
            (eBookOffer != null && this._physicalOfferFound && this.getNoOfferFoundPhysicalTile() && eBookOfferEnabled)) {
            this._bestOffer = eBookOffer;
            this._physicalOfferFound = true;
            if (getCalcServicesThenNgrsEnabled()) {
                this._almaRSServiceAvailable = !physicalOfferEnabled ? 'true' : this._almaRSServiceAvailable;
                this.physicalTileVisible = true;
                this._hasBothOffers = this.physicalTileVisible && this.digitalTileVisible;
            }
        }
    }

    private isEbookTileEnablled() {
        let eBookEnabled = false;
        this.rapidoServices.forEach(service => {
            if(service.serviceType == RAPIDO_EBOOK_TILE) {
                eBookEnabled = true;
                return;
            }
        });
        return eBookEnabled;
    }
    private isPhysicalTileEnablled() {
        let physicalEnabled = false;
        this.rapidoServices.forEach(service => {
            if(service.serviceType == RAPIDO_PHYSICAL_TILE) {
                physicalEnabled = true;
                return;
            }
        });
        return physicalEnabled;
    }

    private isJournalAndTileEnablled() {
        if(!this.isJournal()) {
            return false;
        }
        let journalEnabled = false;
        this.rapidoServices.forEach(service => {
            if(service.serviceType == RAPIDO_JOURNAL_TILE) {
                journalEnabled = true;
                return;
            }
        });
        return journalEnabled;
    }

    private setBestDigitalOffer(response: BestOffer, hash: string) {
        //in case of timeout from RapidILL
        if(response !== null && response.rapidILLTimeOut) {
            this.physicalBestOfferService.setIsTimeOutFromRapid(true);
            response = null;
        }
        this._digitalBestOffer = response;

        this._digitalOfferFound = this.isDigitalOfferFound(this._digitalBestOffer);

        this.resultObject[hash].bestDigitalPolicy = this._digitalBestOffer;

        this.physicalBestOfferService.setResultsObject(this.resultObject, hash);

        this.rapidoServices.forEach(service => {
            if(service.serviceType == RAPIDO_DIGITAL_TILE) {
                this._noOfferFoundDigitalTile = !!((service.noKnownTerms == 'true' && !this._digitalOfferFound) || (service.noKnownTerms == 'false' && this._digitalOfferFound));
                if (this.isJournalAndTileEnablled()) {
                    this._noOfferFoundDigitalTile = false;
                }
            }
        });

        this._digitalTilePlaceholderActive = false;
        this.digitalOfferCalculated = true;
    }

    private setbestOffer(response: mmsIdOfferOutputMap[], hash: string) {
        this._bestOffer = response[hash].bestPhysicalPolicy;
        if (response[hash].bestEbookPolicy && this.isEbookTileEnablled()) {
            this.handleEbookOffer(response, hash, response[hash].bestEbookPolicy);
        }
        this._cannotCalculateOffer = response[hash].cannotCalculateOffer;
        this._digitalBestOffer = response[hash].bestDigitalPolicy;

        this._physicalOfferFound = this.isPhysicalOfferFound(this._bestOffer);
        this._digitalOfferFound = this.isDigitalOfferFound(this._digitalBestOffer);

        this.physicalBestOfferService.setResultsObject(response, hash);

        this.handleRapidoServicesVisibility();

        this._digitalTilePlaceholderActive = false;
        this._physicalTilePlaceholderActive = false;

        this.digitalOfferCalculated = true;
        this.physicalOfferCalculated = true;
    }

    private handleRapidoServicesPlaceholderVisibility(){
        this._hasBothOffers = !this.showOnlyDigitalOffer();

        this.digitalTileVisible = false;
        this.physicalTileVisible = false;
        let journalTileVisible = false;
        let hash = this.jwtUtilService.getDecodedToken().userGroup + '_' + this._mmsId;

        if(!this.rapidoServices || this.rapidoServices.length == 0) {
            this._almaRSServiceAvailable = 'false';
            return;
        } else {
            if(this.isEbookTileEnablled()) {
                let resultObj = this.physicalBestOfferService.getResultsObject();
                if(resultObj && resultObj[hash] && resultObj[hash].bestEbookPolicy) {
                    this.handleEbookOffer(this.resultObject, hash, resultObj[hash].bestEbookPolicy);
                }
            }
            this.rapidoServices.forEach(service => {
                if(service.serviceType == RAPIDO_DIGITAL_TILE){
                    this.digitalTileVisible = true;
                    if(this.digitalOfferCalculated){
                        this._noOfferFoundDigitalTile = !!((service.noKnownTerms == 'true' && !this._digitalOfferFound) || (service.noKnownTerms == 'false' && this._digitalOfferFound));
                    }
                } else if(service.serviceType == RAPIDO_PHYSICAL_TILE && !this.showOnlyDigitalOffer()) {
                    this.physicalTileVisible = true;
                    if(this.physicalOfferCalculated && (!this._bestOffer || !this._bestOffer.ebookOffer)){
                        this._noOfferFoundPhysicalTile = !!((service.noKnownTerms == 'true' && !this._physicalOfferFound) || (service.noKnownTerms == 'false' && this._physicalOfferFound));
                    }
                } else if(service.serviceType == RAPIDO_EBOOK_TILE && !this.showOnlyDigitalOffer() && this._bestOffer && this._bestOffer.ebookOffer) {
                    this.physicalTileVisible = true;
                } else if(service.serviceType == RAPIDO_JOURNAL_TILE) {
                    journalTileVisible = true;
                    if (isShowPhysicalJournalOffer()) {
                        if (this.isJournalResource()) {
                            this.physicalTileVisible = true;
                        }
                    }
                }
            });
            this.initiateTilesVisibility(journalTileVisible);
        }
        this._digitalTilePlaceholderActive = !this.digitalOfferCalculated;
        this._physicalTilePlaceholderActive = !this.physicalOfferCalculated;
    }

    private handleRapidoServicesVisibility() {
        this.digitalTileVisible = false;
        this.physicalTileVisible = false;
        let journalTileVisible = false;

        if(!this.rapidoServices || this.rapidoServices.length == 0){
            this._almaRSServiceAvailable = 'false';
            return;
        } else {
            this.rapidoServices.forEach(service => {
                if(service.serviceType == RAPIDO_DIGITAL_TILE){
                    if((service.noKnownTerms == 'true' && !this._digitalOfferFound) || (service.noKnownTerms == 'false' && this._digitalOfferFound)){
                        this.digitalTileVisible = false;
                    } else {
                        this.digitalTileVisible = true;
                    }
                } else if(service.serviceType == RAPIDO_PHYSICAL_TILE) {
                    if((service.noKnownTerms == 'true' && !this._physicalOfferFound) || (service.noKnownTerms == 'false' && this._physicalOfferFound)  || this.showOnlyDigitalOffer() ){
                        this.physicalTileVisible = false;
                    } else {
                        this.physicalTileVisible = true;
                    }
                } else if(service.serviceType == RAPIDO_JOURNAL_TILE) {
                    journalTileVisible = true;
                    if(isShowPhysicalJournalOffer()){
                        if (this.isJournalResource()) {
                            this.physicalTileVisible = true;
                        }
                    }
                }
            });
            if(this._bestOffer && this._bestOffer.ebookOffer && this.isEbookTileEnablled()) {
                this.physicalTileVisible = true;
            }
            this.initiateTilesVisibility(journalTileVisible)
        }
    }

    private initiateTilesVisibility(journalTileVisible) {
        if(this.isJournal()){
            this.digitalTileVisible = true;
            this.physicalTileVisible = false;
            this._hasBothOffers = false;
            if (journalTileVisible && isShowPhysicalJournalOffer() && this.isJournalResource()){
                this.physicalTileVisible = true;
                this._hasBothOffers = true;
            }
            this._almaRSServiceAvailable = journalTileVisible ? 'true': 'false';
            return;
        }
        if(getRapidILLModeCustomerParameter()){
            this.digitalTileVisible = true;
            this.physicalTileVisible = false;
        }
        if(!this.digitalTileVisible && !this.physicalTileVisible){
            this._almaRSServiceAvailable = 'false';
            return;
        }
        if(this.physicalTileVisible && !this.digitalTileVisible){
            this._digitalOfferFound = false;
            this._digitalBestOffer = undefined;
            this._hasBothOffers = false;
        }
        if(!this.physicalTileVisible && this.digitalTileVisible){
            this._physicalOfferFound = false;
            this._bestOffer = undefined;
            this._hasBothOffers = false;
        }
        this._almaRSServiceAvailable = 'true';
    }

    private isPhysicalOfferFound(physicalBestOffer: BestOffer): boolean {
        return physicalBestOffer && physicalBestOffer.supplyTime >= 0 && physicalBestOffer.loanPeriod >= 0;
    }

    private getEbookOffer(response: mmsIdOfferOutputMap[], hash:string) {
        if (Array.isArray(response)) {
            let eBookBestOffer = response[1][hash].bestEbookPolicy;
            return eBookBestOffer && eBookBestOffer.ebookOffer ? eBookBestOffer : null;
        }
        return null;
    }

    private setPhysicalOffer(response: mmsIdOfferOutputMap[], hash:string) {
        if (Array.isArray(response)) {
            this._bestOffer = response[0][hash].bestPhysicalPolicy;
            this._cannotCalculateOffer = response[0][hash].cannotCalculateOffer;
        } else {
            this._bestOffer =  response[hash].bestPhysicalPolicy;
            this._cannotCalculateOffer = response[hash].cannotCalculateOffer;
        }
    }

    private getNoOfferFoundPhysicalTile() {
        let result = undefined;
        if (this.rapidoServices) {
            this.rapidoServices.forEach(service => {
                if(service.serviceType == RAPIDO_PHYSICAL_TILE) {
                    result = !!((service.noKnownTerms == 'true' && !this._physicalOfferFound) || (service.noKnownTerms == 'false' && this._physicalOfferFound));
                }
            });
        }

        return result == undefined || result === true ? true : false;
    }

    private isRapidoRotaIdFound(physicalBestOffer: BestOffer): boolean {
        if(physicalBestOffer && physicalBestOffer.rotaId){
            return true;
        }
        return false;
    }

    private isDigitalOfferFound(digitalBestOffer: BestOffer): boolean {
        return digitalBestOffer && digitalBestOffer.supplyTime >= 0;
    }

    public isSignedIn() {
        return this.jwtUtilService.isSignedIn();
    }

    get signInLink() {
        return this.ngrsService.signInLink;
    }

    public display() {
        return this._display.display;
    }

    public isShowPhysicalBestOffer(): boolean {
        return this.isShowBestOffer() || this._physicalTilePlaceholderActive;
    }

    public isShowDigitalBestOffer(): boolean {
        return this.isShowBestOffer() || this._digitalTilePlaceholderActive;
    }

    private isShowBestOffer(): boolean {
        return (!(this._openDigitalForm.openDigitalForm) && !(this._openPhysicalForm.openPhysicalForm) && !this._showPickupAnywhereForm) || (this.showSuceesBar() && this.isRequestOK());
    }

    public showSignInMsg(){
        return !(this._openDigitalForm.openDigitalForm) && !(this._openPhysicalForm.openPhysicalForm) && !(this._openBlankForm.openBlankForm) && !this._showPickupAnywhereForm;
    }

    public isAlmaRSServiceAvailable() {
        return this._almaRSServiceAvailable && this._almaRSServiceAvailable === 'true';
    }

    public checkAlmaRSservice(item, isJournal, ngrsCheckFinishedPromiseResolve) {
        var deferred = $q.defer();
        if (getCalcServicesThenNgrsEnabled() && !this.ngrsService.getResponseByRecordId(this._mmsId)) {
            this.$scope.$watch(() => this.fullViewService.calculatePrimaViewItDone(), (newValue, oldValue) => {
                if(newValue === true && !this.ngrsService.getResponseByRecordId(this._mmsId)){
                    return this.performAlmaRSservice(item, isJournal, deferred, ngrsCheckFinishedPromiseResolve);
                }
            });
        } else {
            return this.performAlmaRSservice(item, isJournal, deferred, ngrsCheckFinishedPromiseResolve);
        }
        return deferred.promise;
    }

    private performAlmaRSservice(item, isJournal, deferred, ngrsCheckFinishedPromiseResolve) {

        if (getCalcServicesThenNgrsEnabled()) {
            if(this.ngrsService.ngrsEnabledPromiseByRecordId(this._mmsId)){
                this.ngrsService.ngrsEnabledPromiseByRecordId(this._mmsId).then(response => {
                    this.handleNgrsEnabledResult(response, ngrsCheckFinishedPromiseResolve, deferred);
                });
            }
        }

        // Already calculated - different result
        if(this._mmsId && this.ngrsService.getResponseByRecordId(this._mmsId)){
            this.handleNgrsEnabledResult(this.ngrsService.getResponseByRecordId(this._mmsId), ngrsCheckFinishedPromiseResolve, deferred);
        }

        if (!this._almaRSServiceAvailable && this._mmsId && this.ngrsService.ngrsVisibilityRequestInProgress === false) {
            let physicalServiceId = item ? (item.delivery ? item.delivery.physicalServiceId : null) : null;
            this.ngrsService.isNgrsRSServiceEnabled(this._mmsId, physicalServiceId, item, isJournal).then(response => {
                this.handleNgrsEnabledResult(response, ngrsCheckFinishedPromiseResolve, deferred);
            });
        }
        return deferred.promise;
    }

    private handleNgrsEnabledResult(response, ngrsCheckFinishedPromiseResolve, deferred) {
        this._almaRSServiceAvailable = get(response, 'ngrsEnabled', Boolean);
        this.rapidoServices = get(response, 'services', Array);
        if (this._almaRSServiceAvailable == "true"){
            this._display = { display: 'display:block' };
            this.handleRapidoServicesPlaceholderVisibility();
        }
        ngrsCheckFinishedPromiseResolve();
        deferred.resolve();
    }

    public showLoader(){

        //   1. if DLR is in progress - show loader
        if(this.ngrsService.ngrsVisibilityRequestInProgress === true || this._almaRSServiceAvailable === null){
            return true;
        }
        return false;
    }

    public showSuceesBar(): boolean {
        return this._showMessageBar.showMessageBar;
    }

    public getResponseMessage(): String {
        return this._showMessageBar.message ? this._showMessageBar.message : 'nui.ngrs.request.failed';
    }

    public isRequestOK(): boolean {
        return this._showMessageBar.borrowingRequestOK;
    }

    public showDigitalForm() {
        return this._openDigitalForm.openDigitalForm;
    }

    public showPhysicalForm() {
        return this._openPhysicalForm.openPhysicalForm;
    }

    public showBlankForm() {
        return this._openBlankForm.openBlankForm;
    }

    public isSubmitBlankDigitalForm() {
        return this._isSubmitDigital.isSubmitDigital;
    }

    public isShowMoreDeliveryOptions() {
        return this._showMoreDeliveryOptions.showMoreDeliveryOptions;
    }

    public getOffers() {
        return this._offers;
    }

    public getShowMoreDeliveryOptions() {
        return this._showMoreDeliveryOptions;
    }

    public getDigitalSupplyTime() {
        return this._digitalBestOffer.supplyTime;
    }

    public getMmsId() {
        return this._mmsId;
    }

    public isJournal(){
        let resourceType = getResourceType(this.item);
        if(resourceType == 'journal' || resourceType == 'ejournal'){
            return true;
        }
        return false;
    }

    public isJournalResource(){
        let resourceType = getResourceType(this.item);
        if(resourceType == 'journal'){
            return true;
        }
        return false;
    }

    public showOnlyDigitalOffer(){
        let resourceType = getResourceType(this.item);
        if(resourceType == 'bookitem' || resourceType == 'article' || resourceType == 'web_resource' || resourceType == 'journal' || resourceType == 'ejournal' || getRapidILLModeCustomerParameter() ){
            return true;
        }
        return false;
    }

    public showPickupAnywhereForm(){
        this._showPickupAnywhereForm = true;
    }

    public setPickupInformationFromService(){
        let selectedValues = this.pickupAnywhereService.getSelectedPickupInformation();

        if(selectedValues && selectedValues.pickupInformationUpdated){
            this._pickupInformation.institutionCode = selectedValues.institutionCode;
            this._pickupInformation.libraryId = selectedValues.libraryId;
            this._pickupInformation.pickupInformationUpdated = true;
            this._pickupInformation.chosenPlaceRadio = selectedValues.chosenPlaceRadio;

            if(selectedValues.chosenPlaceRadio && selectedValues.chosenPlaceRadio !== PICKUP_AT_LIBRARY) {
                this._pickupInformationPlaceholder = this.$translate.instant(PICKUP_OPTIONS[selectedValues.chosenPlaceRadio]);
            } else if(selectedValues.institutionName && selectedValues.libraryName) {
                this._pickupInformationPlaceholder = selectedValues.institutionName + ' - ' + selectedValues.libraryName;
            } else {
                this._pickupInformationPlaceholder = selectedValues.institutionName ? selectedValues.institutionName : selectedValues.libraryName;
            }
            let hash = this.jwtUtilService.getDecodedToken().userGroup + '_' + this._mmsId;
            this._bestOffer = undefined;
            this._physicalOfferFound = false;
            this._pickupInformationSelected = true;
            this.offerPromises = [];
            if(this.physicalBestOfferService.getResultsObject()){
                this.physicalBestOfferService.setResultsObject([], hash);
                this._digitalTilePlaceholderActive = true;
                this._physicalTilePlaceholderActive = true;
                let ngrsCheckFinishedPromiseResolve;
                const ngrsCheckFinishedPromise = new Promise((res) => {  ngrsCheckFinishedPromiseResolve = res;});
                ngrsCheckFinishedPromiseResolve();
                this.checkForOffer(this.globalIndexArr, ngrsCheckFinishedPromise);
            }
        }
        this._showPickupAnywhereForm = false;
    }

    public isPartialAlma() {
        return this.configurationUtil.isPartialAlma();
    }

    private getPodPriorityList() {
        if (!this.physicalBestOfferService.isEbookFeatureFlagEnabled) {
            return;
        }
        let hash = this.jwtUtilService.getDecodedToken().userGroup
        if(this.ngrsService.getPodPriorityListResult() && this.ngrsService.getPodPriorityListResult()[hash] && !this.pickUpAnywhereEnabled) {
            this.podPriorityList[hash] = this.ngrsService.getPodPriorityListResult()[hash];
            return this.podPriorityList[hash];
        } else {
            this.ngrsService.getPodPriorityList(getResourceType(this.item), this.pickupInformationInstCode, this.pickupInformationLibraryId, hash).then(response => {
                if(response){
                    this.podPriorityList[hash] = response;
                }
            });
        }
        return this.podPriorityList[hash] ? this.podPriorityList[hash] : {};
    }

    private podListIncludeseBookOffer() {
        let eBookFound = false;
        let hash = this.jwtUtilService.getDecodedToken().userGroup
        if(this.podPriorityList[hash]){
            Object.keys(this.podPriorityList[hash]).forEach(key => {
                if(this.podPriorityList[hash][key] && this.podPriorityList[hash][key] == true){
                    eBookFound = true;
                    return;
                }
            });
        }
        return eBookFound;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/ngrs.directive.ts